import type { PilotLearnerRecord } from './types';

export function flattenLearnerAttempts(record: PilotLearnerRecord) {
  return record.days
    .flatMap((day) => day.attempts.map((attempt) => ({ ...attempt, learningDate: day.learningDate, assignmentId: day.assignmentId })))
    .sort((a, b) => b.completedAt.localeCompare(a.completedAt));
}

export function learnerHistorySummary(record: PilotLearnerRecord) {
  const attempts = flattenLearnerAttempts(record);
  const firstCorrect = attempts.filter((attempt) => attempt.firstAttemptCorrect).length;
  const totalActiveMs = attempts.reduce((sum, attempt) => sum + attempt.duration.activeDurationMs, 0);
  const corrections = attempts.reduce((sum, attempt) => sum + attempt.correctionCount, 0);
  return {
    learningDays: record.days.filter((day) => day.attempts.length > 0).length,
    totalAttempts: attempts.length,
    firstAttemptAccuracy: attempts.length === 0 ? 0 : Math.round((firstCorrect / attempts.length) * 100),
    totalActiveMs,
    corrections,
  };
}
